import { z } from "zod";

import { monthlyAuditDate } from "@/schemas";

import {
  environmentalChecklistItem,
  environmentalChecklistItemWithTicket,
} from "../../../../schemas";

export const resEnvChecklistBathroomSchema = z.object({
  auditDate: monthlyAuditDate,
  locationId: z.string().min(1, "Required"),
  reviewerId: z.string().min(1, "Required"),
  bathroomDescription: z.string().min(1, "Required"),
  bathroomFloor: environmentalChecklistItemWithTicket,
  bathroomGrout: environmentalChecklistItemWithTicket,
  bathroomCeiling: environmentalChecklistItemWithTicket,
  bathroomWall: environmentalChecklistItemWithTicket,
  bathroomShower: environmentalChecklistItemWithTicket,
  bathroomCurtain: environmentalChecklistItem,
  bathroomLight: environmentalChecklistItem,
  bathroomMirror: environmentalChecklistItem,
  bathroomCounter: environmentalChecklistItemWithTicket,
  bathroomToilet: environmentalChecklistItemWithTicket,
  bathroomCaulking: environmentalChecklistItemWithTicket,
  bathroomSink: environmentalChecklistItemWithTicket,
  bathroomComment: z.string().optional(),
});
